import { render, staticRenderFns } from "./ActLogin.vue?vue&type=template&id=2c401c88&"
import script from "./ActLogin.vue?vue&type=script&lang=js&"
export * from "./ActLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports